module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2sJ2Z"))).then(() => parcelRequire('1iHdE'));